<template>
  <section class="perms-filters">
    <div class="section-title">
      <span @click="isOpen = !isOpen">
        {{ $t('permPlacement.listing.filters.title') }}
        <font-awesome-icon :icon="isOpen ? 'sort-up' : 'sort-down'" />
      </span>
    </div>

    <div v-show="isOpen">
      <div class="filter-inputs">
        <div class="date-range">
          <div class="date-range-label">
            {{ $t('permPlacement.listing.filters.startsBetweenLabel') | uppercase }}
          </div>
          <DatePicker
            :value="startDateMin"
            :placeholder="$t('permPlacement.listing.filters.startDateMin')"
            class="date-range-picker"
            @change="onDateChange('startDateMin', $event)"
          />
          <span class="hyphen">-</span>
          <DatePicker
            :value="startDateMax"
            :placeholder="$t('permPlacement.listing.filters.startDateMax')"
            class="date-range-picker"
            @change="onDateChange('startDateMax', $event)"
          />
        </div>

        <TolSelect
          :options="statusesForSelect"
          :selected="selectedStatuses"
          :placeholder="$t('permPlacement.listing.filters.status.all')"
          :multi-select-label="$t('permPlacement.listing.filters.status.plural')"
          multiple
          @change="onStatusChange"
        />
      </div>
    </div>
  </section>
</template>

<script>
import DatePicker from '@/app/components/DatePicker';
import TolSelect from '@/app/components/TolSelect';

import format from 'date-fns/format';

export default {
  name: 'PermPlacementsFilters',
  components: {
    DatePicker,
    TolSelect
  },
  props: {
    currentUser: {
      type: Object,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    startDateMin() {
      return this.filters.dateRangeFilters.startDateMin;
    },
    startDateMax() {
      return this.filters.dateRangeFilters.startDateMax;
    },

    statusesForSelect() {
      let returnValue = [];
      Object.keys(this.filters.statusFilters).forEach(s => {
        returnValue.push({
          label: this.$t('statuses.' + s),
          value: s
        });
      });
      return returnValue;
    },
    selectedStatuses() {
      return this.statusesForSelect.filter(e => this.filters.statusFilters[e.value]);
    }
  },
  methods: {
    formatDate(d) {
      return d ? format(d, 'YYYY-MM-DD') : null;
    },

    onDateChange(field, newValue) {
      this.$emit('change', {
        ...this.filters,
        dateRangeFilters: {
          ...this.filters.dateRangeFilters,
          [field]: newValue
        }
      });
    },

    onStatusChange: function(multiSelectValue) {
      this.$emit('change', {
        ...this.filters,
        statusFilters: {
          draft: multiSelectValue.includes('draft'),
          submitted: multiSelectValue.includes('submitted'),
          processed: multiSelectValue.includes('processed'),
          finished: multiSelectValue.includes('finished'),
          rejected: multiSelectValue.includes('rejected'),
          obsolete: multiSelectValue.includes('obsolete'),
          cancelled: multiSelectValue.includes('cancelled')
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.perms-filters {
  background-color: $background-level-2;

  .section-title {
    font-size: 22px;
    font-weight: bold;
    letter-spacing: -0.22px;
    line-height: 25px;
    margin-bottom: 20px;
    padding: 60px;
    display: flex;
    justify-content: space-between;
    > span {
      cursor: pointer;
    }
  }

  .filter-inputs {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 0px 60px 60px 60px;

    .date-range {
      .date-range-label {
        padding-bottom: 5px;
      }

      .date-range-picker {
        display: inline-block;
      }

      .hyphen {
        display: inline-block;
        margin: 0 10px;
      }
    }
  }
}
</style>
